function charges_report_Reducer(state = null, action) {
    switch (action.type) {
        case 'CHARGES/REPORT/SET':
            return action.charges;
        case 'CHARGES/REPORT/CLEAR':
            return null;
        default:
            return state;
    }
}

export default charges_report_Reducer;
